import React, { useEffect, useState } from "react";
import { Button, CustomStepper } from "InnoUI/components";
import SC from "./style";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import theme from "theme";
import { useSearchParams } from "react-router-dom";
import MessageContent from "./MessageContent";
import AlarmContent from "./AlarmContent";
import NotificationContent from "./NotificationContent";
import RequestContent from "./RequestContent";
import axios from "axios";
import { apiPost } from "api/callApi";
import { byteToKB, readFromLocalStorage, showAlert } from "utils/helper";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import { toJournalAttachmentPayload } from "../utils/attachmentUpload";
import { MAX_FILE_SIZE } from "utils/config";

const AddEditJournal = () => {
  const CART_DOWNLOAD_LINK_PLACEHOLDER = "__CART_DOWNLOAD_LINK__";
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const editing = searchParams.get("editing");
  const folderId = searchParams.get("folderId");
  const [activeStep, setActiveStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const authData = useSelector((state) => state?.authdata?.data || []);
  const [hideFiles, setHideFile] = useState(false);
  const [attachmentId, setAttachmentId] = useState([]);

  const [data, setData] = useState({
    message: `
   <p><br></p><p>Regards,</p><p><span style="color: rgb(255, 153, 0);">${authData?.fullName}</span></p>
  `,
    saveOption: 1,
    requestType: 1,
    primaryalarm: {
      active: 0,
      alarmType: 0,
      alarmTo: authData.email,
    },
    secondaryalarm: {
      active: 0,
      alarmType: 1,
    },
  });

  useEffect(() => {
    const localStorageData = readFromLocalStorage("linkData");
    if (localStorageData?.occupantId) {
      setData((prevData) => ({
        ...prevData,
        linktoproject: localStorageData.occupantId,
        // allfileIds: localStorageData.allfileIds,
        message: `
        <p><br></p>
        <div
          style="
            padding: 16px;
            border: 1px solid #ddd;
            border-radius: 8px;
            background-color: #f9f9f9;
            max-width: 400px;
            margin: auto;
          "
        >
          <p style="font-size: 16px; font-weight: bold; margin-bottom: 8px;">
            Your cart is ready for download! 🎉
          </p>
      
          <a
            href="${localStorageData.link}"
            target="_blank"
            rel="noopener noreferrer"
            style="
              display: inline-block;
              padding: 10px 20px;
              backgroundColor: "#EC810B",
              color: "#fff",
              text-decoration: none;
              border-radius: 5px;
              font-weight: bold;
            "
          >
            &#128229; Download Cart
          </a><br />
      
          ${
            localStorageData.expireIn && localStorageData.expireIn.trim() !== ""
              ? `<p style="margin-top: 10px; color: #555;">
                  &#9203; Download link will expire in <strong>${localStorageData.expireIn}</strong>.
                </p>`
              : ""
          }
        </div>
      
        <p>Regards,</p>
        <p><span style="color: rgb(255, 153, 0);">${
          authData?.fullName
        }</span></p>
      `,
      }));
      localStorage.removeItem("linkData");
    }
  }, []);

  useEffect(() => {
    const localStorageData = readFromLocalStorage("linkAttachmentData");
    setAttachmentId(localStorageData?.allfileIds);
    if (localStorageData?.occupantId) {
      setData((prevData) => ({
        ...prevData,
        linktoproject: localStorageData.occupantId,
        allfileIds: localStorageData.allfileIds,
        message: `
        <p><br></p>
        <p>Regards,</p>
        <p><span style="color: rgb(255, 153, 0);">${authData?.fullName}</span></p>
      `,
      }));
      localStorage.removeItem("linkAttachmentData");
    }
  }, []);

  useEffect(() => {
    const localStorageData = readFromLocalStorage("sendCartJournalData");
    if (
      localStorageData?.allfileIds?.length > 0 ||
      localStorageData?.sendType
    ) {
      const isAttachmentSend = localStorageData.sendType == 4;
      setAttachmentId(isAttachmentSend ? localStorageData?.allfileIds : []);
      setData((prevData) => ({
        ...prevData,
        linktoproject: localStorageData.occupantId || [],
        projectId: localStorageData.projectId,
        projectType: localStorageData.projectType ?? 0,
        allfileIds: localStorageData.allfileIds,
        cartSendType: localStorageData.sendType,
        sendToProject: Boolean(localStorageData.sendToProject),
        message: isAttachmentSend
          ? `
          <p><br></p>
          <p>Regards,</p>
          <p><span style="color: rgb(255, 153, 0);">${authData?.fullName}</span></p>
        `
          : `
          <p><strong>Your cart is ready for download!</strong></p>
          <p><a href="${CART_DOWNLOAD_LINK_PLACEHOLDER}" target="_blank" rel="noopener noreferrer">Download Cart</a></p>
          <p>Download link will expire in <strong>72h</strong>.</p>
          <p>Regards,</p>
          <p><span style="color: rgb(255, 153, 0);">${authData?.fullName}</span></p>
        `,
      }));
      localStorage.removeItem("sendCartJournalData");
    }
  }, []);

  useEffect(() => {
    const localStorageData = readFromLocalStorage("attachData");

    console.log(localStorageData, "localStorageData");

    if (localStorageData) {
      const { fileName, fileType, fileSize, fileUrl, hideFile, fileId } =
        localStorageData;
      if (fileId && !fileUrl) {
        setHideFile(hideFile || false);
        setData((prevData) => ({
          ...prevData,
          files: [
            {
              fileName,
              fileType,
              fileSize,
              fileUrl,
              name: fileName,
              type: fileType,
              size: fileSize,
            },
          ],
          allfileIds: [fileId],
          fileSize: fileSize,
        }));
        localStorage.removeItem("attachData");
      } else if (fileUrl && fileSize > MAX_FILE_SIZE) {
        setHideFile(true);
        setData((prevData) => ({
          ...prevData,
          message: `
          <p><strong>File Name: ${fileName}</strong></p>
          <p><a href="${fileUrl}" target="_blank" rel="noopener noreferrer">Download File</a></p>
          <p>Download link will expire in <strong>6 days</strong>.</p>
          <p>Regards,</p>
          <p><span style="color: rgb(255, 153, 0);">${authData?.fullName}</span></p>
        `,
        }));
        localStorage.removeItem("attachData");
      } else if (fileUrl) {
        setHideFile(hideFile || false);
        setData((prevData) => ({
          ...prevData,
          files: [
            {
              fileName,
              fileType,
              fileSize,
              fileUrl,
              name: fileName,
              type: fileType,
              size: fileSize,
            },
          ],
          allfileIds: [fileId],
          fileSize: fileSize,
        }));
        localStorage.removeItem("attachData");
      } else {
        // Handle the case where fileUrl is not present
        console.warn("No fileUrl found in localStorageData");
      }
    }
  }, []);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );

  const steps = [
    { heading: "Message", description: "Insert Journal Subject & Content" },
    { heading: "Request", description: "Request Type & Role Players" },
    { heading: "Alarm", description: "Primary Alarm & Secondary Pre-alarm" },
    { heading: "Notification", description: "Send Journal Notification" },
  ];

  // handlenext button
  const handleNext = () => {
    console.log(data, "dataNew");

    if (!data.subject) {
      setErrorMessage("Subject is required");
      return;
    }

    // if (type == 0) {
    //   if (!data.linktoproject || data.linktoproject.length === 0) {
    //     if (activeStep === 1) {
    //       showAlert({
    //         title: "Warning",
    //         text: "Please select occupant",
    //         icon: "warning",
    //       });
    //       return;
    //     }
    //   }
    // }

    let active = data.primaryalarm.active,
      alarmTo = data.primaryalarm.alarmTo,
      alarmTime = data.primaryalarm.alarmTime,
      alarmDate = data.primaryalarm.alarmDate;

    if (
      activeStep == 2 &&
      ((active == 1 && !alarmDate) ||
        (active == 1 && !alarmTo) ||
        (active == 1 && !alarmTime))
    ) {
      showAlert({
        title: "Warning",
        text: "Primary Alarm details are required",
        icon: "warning",
      });
      return;
    }
    if (data.requestType == 3 && (!data.users || data.users.length === 0)) {
      showAlert({
        title: "Warning",
        text: "User are required!",
        icon: "warning",
      });
      return;
    }
    if (activeStep == 1 && data.requestType > 2) {
      setData((prevData) => ({
        ...prevData,
        primaryalarm: {
          ...prevData.primaryalarm,
          active: 1,
        },
      }));
    }

    let sactive = data.secondaryalarm.active,
      salarmTo = data.secondaryalarm.alarmTo,
      salarmTime = data.secondaryalarm.alarmTime,
      salarmDate = data.secondaryalarm.alarmDate,
      smessage = data.secondaryalarm.message;

    if (
      (sactive == 1 && !salarmDate) ||
      (sactive == 1 && !salarmTo) ||
      (sactive == 1 && !salarmTime) ||
      (sactive == 1 && !smessage)
    ) {
      showAlert({
        title: "Warning",
        text: "Secondary Alarm details are required",
        icon: "warning",
      });
      return;
    }

    setErrorMessage("");
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  // handleBack
  const handleBack = () => {
    if (
      data.requestType == 3 &&
      (!data.users ||
        data.users.length === 0 ||
        !data.roles ||
        data.users.length === 0)
    ) {
      setData((prevData) => ({
        ...prevData,
        requestType: 1,
      }));
    }

    let active = data.primaryalarm.active,
      alarmTo = data.primaryalarm.alarmTo,
      alarmTime = data.primaryalarm.alarmTime,
      alarmDate = data.primaryalarm.alarmDate;

    if (active === 1 && (!alarmDate || !alarmTo || !alarmTime)) {
      // Set active to 0 if required fields are not filled
      setData((prevData) => ({
        ...prevData,
        primaryalarm: {
          ...prevData.primaryalarm,
          active: 0,
        },
      }));
    }
    // Similarly, handle secondary alarm validation
    let sactive = data.secondaryalarm.active,
      salarmTo = data.secondaryalarm.alarmTo,
      salarmTime = data.secondaryalarm.alarmTime,
      salarmDate = data.secondaryalarm.alarmDate,
      smessage = data.secondaryalarm.message;

    if (
      sactive === 1 &&
      (!salarmDate || !salarmTo || !salarmTime || !smessage)
    ) {
      // Set secondary alarm active to 0 if required fields are not filled
      setData((prevData) => ({
        ...prevData,
        secondaryalarm: {
          ...prevData.secondaryalarm,
          active: 0,
        },
      }));
    }
    // Move to the previous step if applicable
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const {
    REACT_APP_BASE_URL: baseURL,
    REACT_APP_REQUEST_TIMEOUT: timeout,
    REACT_APP_API_KEY,
  } = process.env;

  let accessToken = REACT_APP_API_KEY;
  let userAuth = readFromLocalStorage("userAccessToken");
  let BASE_URL = baseURL || `${window.location.origin}/api`;
  userAuth = userAuth === null ? "" : userAuth;

  // handleSubmit
  const handleSubmit = async (e, isFinish = false) => {
    e.preventDefault();

    if (data.attachmentUploading) {
      showAlert({
        title: "Info",
        text: "Please wait until attachments finish uploading.",
        icon: "info",
      });
      return;
    }

    if (!data.subject) {
      setErrorMessage("Subject is required");
      return;
    }

    const payload = { ...data };

    // Check if sendTo is missing or empty
    if (!payload?.sendTo && isFinish) {
      // if sendTo is undefined, null, or empty string
      payload.saveOption = 1;
    } else {
      // if sendTo has a value (valid email/ids), keep saveOption or default to 0
      payload.saveOption = payload.saveOption ?? 0;
    }

    // Create a FormData object
    const formData = new FormData();

    // Append scalar fields
    formData.append("message", payload.message || "");
    formData.append("subject", payload.subject || "");
    formData.append("requestType", payload.requestType || "");
    formData.append("saveOption", payload.saveOption);
    formData.append("folderId", folderId);
    if (payload.cartSendType) {
      formData.append("cartSendType", payload.cartSendType);
      formData.append("cartProjectId", payload.projectId || projectId);
      formData.append("cartProjectType", payload.projectType ?? 0);
    }

    if (payload.fileId) {
      formData.append("fileId", payload.fileId || null);
    }

    const uploadedAttachments = (payload.files || []).filter(
      (file) => file?.isUploadedAttachment || file?.fileUrl,
    );
    if (uploadedAttachments.length > 0 && !payload.allfileIds?.length) {
      formData.append(
        "attachments",
        JSON.stringify(toJournalAttachmentPayload(uploadedAttachments)),
      );
    }
    // Append primaryalarm as JSON string
    formData.append("primaryalarm", JSON.stringify(payload.primaryalarm || {}));

    // Append secondaryalarm as JSON string
    formData.append(
      "secondaryalarm",
      JSON.stringify(payload.secondaryalarm || {}),
    );

    // Append roles array
    if (payload.roles && payload.roles.length > 0) {
      payload.roles.forEach((role) => {
        formData.append("roles[]", role);
      });
    }

    // Append users array
    if (payload.users && payload.users.length > 0) {
      payload.users.forEach((user) => {
        formData.append("users[]", user);
      });
    }
    if (payload.allfileIds && payload.allfileIds.length > 0) {
      payload.allfileIds.forEach((user) => {
        formData.append("allfileIds[]", user);
      });
      formData.set("files", JSON.stringify([]));
    }
    // Append users array
    if (payload.linktoproject && payload.linktoproject.length > 0) {
      payload.linktoproject.forEach((user) => {
        formData.append("linktoproject[]", user);
      });
    }

    // Append email fields
    formData.append("sendTo", payload.sendTo || "");
    formData.append("sendCc", payload.sendCc || "");
    formData.append("sendBcc", payload.sendBcc || "");

    try {
      setLoading(true);
      let endpoint = `/v1/journal/addjournal/`;
      if (type == 0) {
        // type 0 is a project
        const shouldCreateProjectJournal =
          payload.cartSendType && payload.sendToProject;
        let id = payload.projectId || projectId;
        let t = 0;

        if (payload.linktoproject && !shouldCreateProjectJournal) {
          id =
            payload.linktoproject.length > 0
              ? payload?.linktoproject[0]
              : payload.projectId || projectId;
          t = payload.linktoproject.length > 0 ? 1 : 0;
        }

        endpoint += `${id}/${t}`;
      } else if (type == 1) {
        // type 1  is a occupant
        endpoint += `${projectId}/${1}`;
      } else {
        endpoint += `${projectId}/${type}`;
      }
      const url = BASE_URL + endpoint;
      const requestTimeout = timeout ? parseInt(timeout, 10) * 1000 : 180000;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          api_key: accessToken,
          Authorization: `Bearer ${userAuth}`,
        },
        timeout: requestTimeout,
      });
      setLoading(false);
      showAlert({
        title: "Success",
        text: response?.data?.message || "File updated successfully.",
        icon: "success",
      });
      if (payload.requestType == 1 || payload.requestType == 2) {
        navigate(-1);
      } else {
        navigate(-1);
      }
    } catch (error) {
      console.error("Error making API call:", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
      });
      setLoading(false);
    }
  };

  const cleanupDraftUploads = async () => {
    const draftUploads = (data?.files || []).filter(
      (file) => file?.isUploadedAttachment && file?.fileUrl,
    );

    await Promise.all(
      draftUploads.map((file) =>
        apiPost("/v1/aws/file/deletefile", { fileKey: file.fileUrl }).catch(
          (error) => console.warn("Unable to cleanup draft attachment", error),
        ),
      ),
    );
  };

  const handleBackClick = async () => {
    if (data?.attachmentUploading) {
      showAlert({
        title: "Info",
        text: "Please wait until attachments finish uploading.",
        icon: "info",
      });
      return;
    }
    await cleanupDraftUploads();
    navigate(-1);
  };

  return (
    <>
      <CustomBreadcrumb />

      <SC.NameContainer>
        <SC.ArrowC>
          <SC.ArrowBackIcon onClick={() => handleBackClick()} />
          <SC.Name>{editing ? "Edit Journal" : "New Journal"}</SC.Name>
        </SC.ArrowC>
      </SC.NameContainer>

      {!editing && (
        <SC.CustomStepperContainer>
          <CustomStepper
            steps={steps}
            handleNext={handleNext}
            handleBack={handleBack}
            activeStep={activeStep}
          />
        </SC.CustomStepperContainer>
      )}

      <SC.CardContainerStyle>
        <SC.ButtonContaiiner style={{ margin: "0px 0px 10px 0px" }}>
          {activeStep == 0 && (
            <Button
              caption="Cancel"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={handleBackClick}
            />
          )}

          {activeStep > 0 && (
            <Button
              caption="Back"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              disabled={activeStep === 0 || loading}
              onClick={handleBack}
            />
          )}
          {activeStep == 0 && (
            <Button
              caption="Finish"
              fontSize="12px"
              color="white"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={handleSubmit}
            />
          )}

          {activeStep < steps.length - 1 && (
            <Button
              caption={"Next"}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              disabled={activeStep === steps.length - 1}
              onClick={handleNext}
            />
          )}

          {activeStep === steps.length - 1 && (
            <Button
              caption={loading ? "Submitting..." : "Submit"}
              type="submit"
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              onClick={handleSubmit}
              disabled={loading || data?.attachmentUploading}
            />
          )}
        </SC.ButtonContaiiner>

        {editing ? (
          <MessageContent
            setData={setData}
            data={data}
            errorMessage={errorMessage}
          />
        ) : (
          <>
            {activeStep === 0 && (
              <MessageContent
                setData={setData}
                data={data}
                errorMessage={errorMessage}
                hideFiles={hideFiles}
                attachmentId={attachmentId}
              />
            )}
            {activeStep === 1 && (
              <RequestContent setData={setData} data={data} />
            )}
            {activeStep === 2 && <AlarmContent setData={setData} data={data} />}
            {activeStep === 3 && (
              <NotificationContent
                setData={setData}
                data={data}
                loading={loading}
              />
            )}
          </>
        )}

        <SC.ButtonContaiiner>
          {activeStep == 0 && (
            <Button
              caption="Cancel"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={handleBackClick}
            />
          )}

          {activeStep > 0 && (
            <Button
              caption="Back"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              disabled={activeStep === 0 || loading}
              onClick={handleBack}
            />
          )}
          {activeStep == 0 && (
            <Button
              caption="Finish"
              fontSize="12px"
              color="white"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={(e) => handleSubmit(e, true)}
            />
          )}

          {activeStep < steps.length - 1 && (
            <Button
              caption={"Next"}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              disabled={activeStep === steps.length - 1}
              onClick={handleNext}
            />
          )}

          {activeStep === steps.length - 1 && (
            <Button
              caption={loading ? "Submitting..." : "Submit"}
              type="submit"
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              onClick={(e) => handleSubmit(e, false)}
              disabled={loading || data?.attachmentUploading}
            />
          )}
        </SC.ButtonContaiiner>
      </SC.CardContainerStyle>
    </>
  );
};

export default AddEditJournal;
